/* import __COLOCATED_TEMPLATE__ from './dispute-form-date.hbs'; */
import Component from '@ember/component';
import { computed } from '@ember/object';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  dropdown: null,
  date: computed('componentName', 'componentText', 'inputs.@each.{name,value}', function () {
    const input = this.inputs?.findBy('name', this.componentName);
    if (input) {
      return input.value;
    } else {
      return this.componentText;
    }
  }),
  // eslint-disable-next-line ember/no-actions-hash
  actions: {
    setDropdown(dropdown) {
      this.set('dropdown', dropdown);
    },
    updateAndClose(event) {
      this.updateInput(event.detail.startDate);
      this.dropdown.closeDropdown();
    }
  }
});